import { render, staticRenderFns } from "./PresentationButtons.vue?vue&type=template&id=4dde0c42&scoped=true&"
import script from "./PresentationButtons.vue?vue&type=script&lang=js&"
export * from "./PresentationButtons.vue?vue&type=script&lang=js&"
import style0 from "./PresentationButtons.vue?vue&type=style&index=0&id=4dde0c42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dde0c42",
  null
  
)

export default component.exports